import React, { useState, useEffect, useRef,useCallback } from 'react';
import { fetchJson,prepareFilterPayload } from '@utils/fetchJson';
import {Filter,ChevronUp, FilterIcon, RefreshCcw, X } from 'lucide-react';
import FilterOverlay from './FilterOverlay';
import { formatFiltersForAPI,convertServerFilterData } from '@utils/fetchJson';
import 'react-datepicker/dist/react-datepicker.css';
import SmartDropdown from '@components/filter/SmartDropdown';
import { AnimatePresence, motion } from 'framer-motion';
import { useClickAway } from 'react-use';
import { API_BASE_URL } from '@config';
import SavedFilterManager from './SaveFilter';
import debounce from 'lodash/debounce';
import TooltipInfo from '@components/TooltipInfo';
const DynamicFilter = ({ menuId,
  fields,
  metadata,
  overrideFields={},
  skipFields = [],
  handleRefresh,
  onFreeTextChange,
  onApply, columnMappings = {} }) => {
  const [availableFields, setAvailableFields] = useState([]);
  const [filters, setFilters] = useState([]);
  const [textSearch, setTextSearch] = useState('');
  const [savedFilters, setSavedFilters] = useState([]);
  const [showSavePopup, setShowSavePopup] = useState(false);
  const [showFilterPopup, setShowFilterPopup] = useState(false);
  //const filterRef = useRef();
  const [activeFilterName, setActiveFilterName] = useState('');
  const [activeFilterId, setActiveFilterId] = useState(null);
  const [visibility, setVisibility] = useState('Public');
  const [searchField, setSearchField] = useState('');
  const [editingFilterIndex, setEditingFilterIndex] = useState(null);
  const [showAddField, setShowAddField] = useState(false);
  const dropdownRef = useRef(null);
  const wrapperRef = useRef(null);
  const [collapsed, setCollapsed] = useState(true);
  const numericTypes = ["tinyint","smallint","mediumint","int","bigint","decimal","float","double","real","bit",'number'];
  //const { setFilterCol } = useLayout();
  const comparatorOptions = [
    { label: 'Is In', value: 'is_in' },
    { label: 'Start With', value: 'start_with' },
    { label: 'End With', value: 'end_with' },
    { label: 'Equal To', value: 'equal_to' },
    { label: 'Not Equal To', value: 'not_equal_to' },
    { label: 'Is Empty', value: 'is_empty' },
    { label: 'Is Not Empty', value: 'is_not_empty' },
    // { label: 'Range', value: 'range' }
  ];
  const numericOptions = [
    { label: 'Is In', value: 'is_in' },
    { label: 'Greater Than', value: 'greater_than' },
    { label: 'Less Than', value: 'less_than' },
    { label: 'Equal To', value: 'equal_to' },
    { label: 'Not Equal To', value: 'not_equal_to' },
    { label: 'Is Empty', value: 'is_empty' },
    { label: 'Is Not Empty', value: 'is_not_empty' },
    // { label: 'Range', value: 'range' }
  ];

  const selectedListOptions = [
    { label: 'Equal To', value: 'equal_to' },
    { label: 'Not Equal To', value: 'not_equal_to' },
    { label: 'Is Empty', value: 'is_empty' },
    { label: 'Is Not Empty', value: 'is_not_empty' },
  ];


  const dateConditionList = [
    { label: 'Today', value: 'today' },
    { label: 'Tomorrow', value: 'tomorrow' },
    { label: 'Yesterday', value: 'yesterday' },
    { label: 'Exact Date', value: 'exact_date' },
    { label: 'This Month', value: 'this_month' },
    { label: 'This Week', value: 'this_week' },
    { label: 'Date Range', value: 'date_range' },
    { label: 'Is Empty', value: 'is_empty' },
    { label: 'Is Not Empty', value: 'is_not_empty' }
  ];

  const conditionSymbols = {
  equal_to: '=',
  not_equal_to: '≠',
  is_in: '∈',
  is_not_in: '∉',
  is_empty: '∅',
  is_not_empty: '≠∅',
  start_with: '⇾',
  end_with: '⇽',
  range: '↔',
  today: '=',
  tomorrow: '=',
  yesterday: '=',
  this_week: '=',
  this_month: '=',
  exact_date: '=',
};
const renderFilterValue = (f) => {
    const formatDate = (date) =>
    new Date(date).toLocaleDateString('en-GB').split('/').join('-');
    const today = new Date();
    const getMonthName = (d) =>
      d.toLocaleString('en-US', { month: 'long' });

  const getOrdinal = (n) => {
    const s = ["th", "st", "nd", "rd"];
    const v = n % 100;
    return n + (s[(v - 20) % 10] || s[v] || s[0]);
  };

  const getWeekNumberOfMonth = (date) => {
    const firstDay = new Date(date.getFullYear(), date.getMonth(), 1);
    const dayOfWeek = firstDay.getDay() || 7;
    const offsetDate = date.getDate() + dayOfWeek - 1;
    return Math.ceil(offsetDate / 7);
  };

  switch (f.condition) {
    case 'today':
      return formatDate(today);

    case 'tomorrow':
      return formatDate(new Date(today.getTime() + 1 * 24 * 60 * 60 * 1000));

    case 'yesterday':
      return formatDate(new Date(today.getTime() - 1 * 24 * 60 * 60 * 1000));

    case 'this_month': {
      const month = getMonthName(today);
      const year = today.getFullYear();
      return `${month} ${year}`;
    }

    case 'this_week': {
      const weekNumber = getWeekNumberOfMonth(today);
      const month = getMonthName(today);
      const year = today.getFullYear();
      return `${getOrdinal(weekNumber)} week of ${month} ${year}`;
    }

    case 'exact_date':
      return formatDate(f.value?.from);

    case 'date_range':
      return `${formatDate(f.value?.from)} / ${formatDate(f.value?.to)}`;

    default:
      return Array.isArray(f.value)
        ? f.value.map((v) => v.label || v).join(', ')
        : f.value?.label || f.value;
  }
};

  useClickAway(wrapperRef, () => {
    if (showSavePopup) {
      setShowSavePopup(false);
    }
  });
   const wrapperFilterRef = useRef(null);
  useClickAway(wrapperFilterRef, () => {
    if (showFilterPopup) {
      setShowFilterPopup(false);
    }
  });
  useEffect(() => {
  //console.log("editingFilterIndex changed:", filters);
}, [filters]);

  // useEffect(() => {
  //   if (filterRef.current) {
  //     const resize = () => {
  //       setFilterCol(filterRef.current.offsetHeight);
  //     };
  //     resize();
  //     window.addEventListener('resize', resize);
  //     return () => window.removeEventListener('resize', resize);
  //   }
  // }, [setFilterCol]);

  useEffect(() => {
  const handleClickOutside = (event) => {
    if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
      setShowAddField(false);
    }
  };
  document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  // useEffect(() => {
  //   // add custom feilds

  //   const validFields = fields.filter(f => !skipFields.includes(f.column_name));
  //   console.log("check availble Fields",validFields);
  //   setAvailableFields(validFields);
  //   loadSavedFilters();
  // }, [fields]);
useEffect(() => {
  if (!fields?.length && !metadata?.dynamicFields?.length) return;

  const coreFields = fields || [];
  const customFields = metadata?.dynamicFields || [];
  
  const mergedFields = [
    ...coreFields,
    ...customFields.filter(
      cf => !coreFields.some(f => f.column_name === cf.column_name)
    )
  ];
  const validFields = mergedFields.filter(
    f => !skipFields.includes(f.Field)
  );
//  console.log(skipFields);
//   console.log(validFields);
  setAvailableFields(validFields);
  loadSavedFilters();

}, [fields?.length, metadata?.dynamicFields?.length]);


  const filteredFields = availableFields.filter(f => {
  const label = (f.Field || '').toLowerCase();
  const transformed = f.Field?.replace(/_/g, ' ').replace(/\b\w/g, l => l.toUpperCase()) || '';
  return label.includes(searchField.toLowerCase()) || transformed.toLowerCase().includes(searchField.toLowerCase());
},[menuId]);
  const loadSavedFilters = async () => {
      const res = await fetchJson(`${API_BASE_URL}/filterMasterList`, {
        method: 'POST',
        body: JSON.stringify({ menu_id: menuId,select:"filter_id,filter_name,is_default,visibility"})
      });
      if (res?.flag === 'S') {
        setSavedFilters(res.data);
      }
    };
    const getColumnLabel = (colName) => {
      //if(colName === undefined) return;
    if (columnMappings[colName]) {
      return columnMappings[colName];
    }
    // Fallback: format the column name nicely
    return colName
      .replace(/_/g, ' ')
      .replace(/\b\w/g, (char) => char.toUpperCase());
  };
  const debouncedSearch = useCallback(
  debounce((val) => {
    onFreeTextChange(val); // 🔁 Actual API or search trigger
  }, 300), // delay in ms
  [] // only create once
);

    const handleSearchChange = (e) => {
      const value = e.target.value;
      setTextSearch(value)
      debouncedSearch(value)
    }
    useEffect(() => {
  return () => {
    debouncedSearch.cancel();
  };
}, [debouncedSearch]);
    //onFilternameUpdate(name);
    //setFilterNameInput(exists ? `${name} (Copy)` : name);
  // const addFilter = (fieldObj = {}) => {
  //   setFilters(prev => [...prev, {"defination":fieldObj,column:fieldObj.Field, condition: '', value: '' }]);
  //   setShowAddField(false);
  //   setEditingFilterIndex(filters.length);
  // };
  const addFilter = (fieldObj = {}) => {
    const isDynamic = !!fieldObj.fieldID;
    const label = isDynamic ? fieldObj.fieldLabel : fieldObj.Field;
    const column = isDynamic ? fieldObj.column_name : fieldObj.Field;
    const type = (fieldObj.Type || fieldObj.fieldType || '').toLowerCase();
    let conditionList;
    const listType = ["drop down list","checkbox list","radio list","radiolist","checkboxlist","dropdown","smartselectinput","selectinput"];
    //console.log("Selected Type",fieldObj);
    if (type === 'date' || type === 'datetime' || type === "date picker") {
      conditionList = dateConditionList;
    } else if (listType.includes(type)
      || type.startsWith("enum(") 
    ) {
      conditionList = selectedListOptions;
    }else if( numericTypes.includes(type)){
        conditionList = numericOptions;
    }
    else {
      conditionList = comparatorOptions;
    }
    const defaultCondition = conditionList[0]?.value || '';
    // console.log("set default list", type);
    // console.log("set default list", conditionList);
    setFilters(prev => [
      ...prev,
      {
        defination: fieldObj,
        column,
        isDynamic:isDynamic,
        columnName:column,
        label,
        condition:defaultCondition,
        value: ''
      }
    ]);
    setShowAddField(false);
    setEditingFilterIndex(filters.length);
  };
  const onSelectSavedFilter = async (filter_id) =>{
    
    setActiveFilterId(filter_id);
    const res = await fetchJson(`${API_BASE_URL}/filterMaster/${filter_id}`, {
      method: 'GET',
    });
    if (res?.flag === 'S'){
        const conditions = JSON.parse(res?.data?.[0]?.conditions || '{}');
        const convertedFilters = convertServerFilterData(conditions,fields);
        setActiveFilterName(res.data[0].filter_name);
        setVisibility(res.data[0].visibility);
        //console.log(convertedFilters);
        setFilters(convertedFilters);
        onApply({ filters: conditions });
      }
  }
  const removeFilter = (index) => {
    const updated = [...filters];
    updated.splice(index, 1);
    setFilters(updated);
    const payload = formatFiltersForAPI(updated);
    onApply({ filters: payload });
  };
  const handleReset = () => {
    setActiveFilterName('');
    setFilters([]);
    setActiveFilterId(null);
    onApply({ filters:{}});
  };
  const handleFilterChange = (key, val) => {
    const updated = [...filters];
    updated[editingFilterIndex] = {
      ...updated[editingFilterIndex],
      [key]: val
    };
    setFilters(updated);
  };
  const toggleDefault = (id) => {
    setSavedFilters(prev =>
      prev.map(f =>
        f.filter_id === id
          ? { ...f, is_default: f.is_default === 'yes' ? 'no' : 'yes' }
          : { ...f, is_default: 'no' } // only one can be default
      )
    );
  };

  const saveFilter = async (activeFilterId,type='new',nameArg = activeFilterName, visibilityArg = visibility) => {
    // check is update or new 
    const method = type === 'new' ? 'PUT':'POST';
    const id = (activeFilterId == null || activeFilterId === undefined) ? '':activeFilterId;
    const payload = formatFiltersForAPI(filters);
    const response = await fetchJson(`${API_BASE_URL}/filterMaster/${id}`, {
      method:method,
      body: JSON.stringify({
        filter_id: activeFilterId,
        is_default: 'no',
        menu_id: menuId,
        filter_name:nameArg,
        conditions: JSON.stringify(payload),
        visibility:visibilityArg,
      })
    });
     if (response?.filter_id) {
      setActiveFilterId(response.filter_id);
    }
    setShowSavePopup(false);
    await loadSavedFilters();
  };
  const handleDeleteFilter = async(id) => {
      await fetchJson(`${API_BASE_URL}/filterMaster/delete`, {
      method:'POST',
      body: JSON.stringify({
        filter_id: id,
      })
    });
    setSavedFilters(prev => prev.filter(f => f.filter_id !== id));
  };


  return (
    <div className="relative">
      {collapsed && (
      <div className="flex flex-wrap items-center gap-2 mb-3">
        <div className="relative max-w-xs w-full md:w-1/4">
  <input
    type="text"
    placeholder="Search..."
    value={textSearch}
    onChange={handleSearchChange}
    className="border px-3 py-1 rounded w-full pr-8"
  />
  {textSearch && (
    <button
      type="button"
      className="absolute right-2 top-1/2 -translate-y-1/2 text-gray-400 hover:text-gray-600"
      onClick={() => handleSearchChange({ target: { value: '' } })}
      tabIndex={-1}
      aria-label="Clear search"
    >
      <X size={18} />
    </button>
  )}
</div>
        {/* <input
          type="text"
          placeholder="Search..."
          value={textSearch}
         onChange={(e) => handleSearchChange(e)}
          className="border px-3 py-1 max-w-xs rounded w-full md:w-1/4"
        /> */}
        <div className='relative'>
          <TooltipInfo text="Saved Filter List">
          <button ref={wrapperFilterRef} onClick={() => setShowFilterPopup(showFilterPopup ? false : true)} className="p-2 bg-primary text-white rounded">
            <Filter size={16} />
          </button>
          </TooltipInfo>
          {showFilterPopup && (
          <AnimatePresence>
            <motion.div ref={wrapperFilterRef} className="absolute w-72 bg-white border rounded shadow z-30">
            <ul className="divide-y">
              
              {savedFilters.length > 0 ? (savedFilters.map((filter) => (
                <li
                  key={filter.filter_id}
                  className="flex justify-between items-center py-2 px-2 rounded hover:bg-gray-50 group">
                  {/* Filter name and default badge */}
                  <div className="flex items-center gap-2">
                    <span  onClick={() => onSelectSavedFilter(filter.filter_id)} className="text-sm">{filter.filter_name}<br/><small>{filter.visibility}</small></span>
                    {filter.is_default === 'yes' && (
                      <span className="text-xs text-green-600 bg-green-100 px-2 py-0.5 rounded">
                        Default
                      </span>
                    )}
                  </div>

                  {/* Right-side actions */}
                  <div className="flex items-center gap-3">
                    {/* Set/Remove Default (visible only on hover) */}
                    {/* Hide this for now. will letter add default filter */}
                    {/* <button
                      onClick={() => toggleDefault(filter.filter_id)}
                      className="text-xs text-blue-600 hover:underline opacity-0 group-hover:opacity-100 transition"
                    >
                      {filter.is_default === 'yes' ? 'Remove Default' : 'Set as Default'}
                    </button> */}

                    {/* Delete icon (always visible) */}
                    <button
                      onClick={() => handleDeleteFilter(filter.filter_id)}
                      className="text-red-500 hover:text-red-700"
                      title="Delete filter"
                    >
                      🗑️
                    </button>
                  </div>
                </li>
              ))):(
                <li className="flex justify-between items-center py-2 px-2 rounded text-gray-500 hover:bg-gray-50 group">No Filters Created</li>
              )}
            </ul>
          </motion.div>
          </AnimatePresence>)}
          <TooltipInfo text="Refresh Data">
           <button className="p-2 ml-2 bg-gray-100 rounded-md hover:bg-gray-200" onClick={() =>handleRefresh()}>
                    <RefreshCcw size={16} />
          </button>
          </TooltipInfo>
        </div>
         {activeFilterName && (
          <div className="relative flex-none flex items-center h-[34px] px-3 py-1 mr-1 items-center bg-primary text-white rounded-md">
            <span className="mr-2">{activeFilterName}</span>
            <button
              onClick={handleReset} className="text-white hover:text-red-600 font-bold" title="Clear filter">×</button>
          </div>
        )}
         {filters.map((f, i) => (
          <div key={i} className="relative flex-none flex items-center h-[34px] px-3 py-1 border mr-2 items-center bg-gray-100 rounded-md">
            {editingFilterIndex === i && (
              <div className="absolute z-50 left-0">
                <FilterOverlay
                  filter={f}
                  comparatorOptions={comparatorOptions}
                  selectedListOptions={selectedListOptions}
                  dateConditionList={dateConditionList}
                  numericOptions={numericOptions}
                  numericTypes={numericTypes}
                  availableFields={availableFields}
                  overrideFields={overrideFields}
                  columnMappings={columnMappings}
                  onCancel={() => setEditingFilterIndex(null)}
                  onApply={(updatedRow) => {
                    //console.log("after apply",updatedRow);
                      const { updatedFilters, payload } = prepareFilterPayload(filters, editingFilterIndex, updatedRow);
                      //console.log("after paylod",payload);
                      setFilters(updatedFilters);
                      setEditingFilterIndex(null);
                      onApply({ filters: payload });
                  }}
                  onChange={(key, val) =>{
                    handleFilterChange(key, val)}}
                />
              </div>
            )}
            <div className="flex items-center max-w-xs bg-gray-100 text-sm rounded p-1 space-x-2 cursor-pointer" onClick={() => setEditingFilterIndex(i)}>
            <span
              title={`${getColumnLabel(f.column)} ${conditionSymbols[f.condition] || getColumnLabel(f.condition)} ${renderFilterValue(f)}`}
              className="truncate text-ellipsis overflow-hidden whitespace-nowrap max-w-[12rem] text-sm text-gray-800"
            >
              <span className="text-gray-600 pr-1">{getColumnLabel(f.column)}</span>
              <span className="text-gray-400 pr-1">
                {conditionSymbols[f.condition] || getColumnLabel(f.condition)}
              </span>
              <span className="text-gray-700">
                {renderFilterValue(f)}
              </span>
            </span>

              <button onClick={(e) => { e.stopPropagation(); removeFilter(i); }} className="ml-2 text-gray-500 hover:text-red-600 flex-shrink-0" title="Remove filter">✕</button>
            </div>
          </div>
        ))}

        <div className="relative" ref={dropdownRef}>
          <SmartDropdown filters={filters} filteredFields={filteredFields}  addFilter={(field) => addFilter(field)} getColumnLabel={getColumnLabel}/> 
        </div>
        <div className="relative" ref={dropdownRef}>
        {filters.length > 0 && (
         <SavedFilterManager
            existingFilterNames={activeFilterName}
            // onFilternameUpdate={(name)=>{
            //   setActiveFilterName(name);
            // }}
            visibility={visibility}
            setVisibility={setVisibility}
            onUpdateFilter={(name, visibility) => {
              setActiveFilterName(name);
              setVisibility(visibility);
              saveFilter(activeFilterId,'update',name, visibility); // function that updates in DB or localStorage
            }}
            onCreateNewFilter={(name, visibility) => {
              setActiveFilterName(name);
              setVisibility(visibility);
              setActiveFilterId(null);
              saveFilter(activeFilterId,'new',name, visibility); // function to insert into your DB or localStorage
            }}
          />
      )}
      </div>
      </div>
      )}
      <button
        onClick={() => { setCollapsed(!collapsed);  //setFilterCol(!collapsed);
        }}
        className="absolute -bottom-7 left-1/2 -translate-x-1/2 bg-white border rounded-full p-2 z-25 shadow hover:bg-gray-100"
        title={collapsed ? 'Expand Filters' : 'Collapse Filters'}
      >
        {collapsed ? <ChevronUp size={14} /> : <FilterIcon size={14} />}
      </button>
    </div>
  );
};

export default DynamicFilter;
